export const formatNumber = (
  value: unknown,
  allowIntegerApproximations: boolean = true
): string => {
  if (typeof value !== 'number') {
    return String(value);
  }

  // *** BEWARE AND BEWARE AND BEWARE ***
  // If you have arrived here because a number you expect is not the number that
  // is being returned by this function, you might be suffering from the bad
  // behavior of IEEE754 floating point numbers. If the input number to this
  // function is 2^53 or greater (or less than -2^53), the precision of that
  // number will be an approximation. This means that not every number above or
  // below those bounds can be represented by the bits available to JS's number
  // type.
  //
  // If you are getting the number from a JSON response, stop here. It's likely
  // that your problem is unfixable. Your choices are:
  //
  //  1. Allow BigInt to approximate the number for you if the number is. This
  //     will result in unpredictable approximations between digits. For
  //     examaple, the true integers 2305843009213950720..2305843009213951232
  //     will be represented by the integer 2,305,843,009,213,950,976.
  //
  //  2. Let JS present you with a decimal-rounded approximation. So for that
  //     same range of digits, you will get the value 2,305,843,009,213,951,000.
  //     This is just as correct/accurate as the above, but it looks less
  //     precise.
  //
  // If you are getting the number from a frontend-only computed value, you can
  // attempt to refactor this code to use the BigInt number type. This allows
  // for arbitrary/infinite precision for integers. If you need big decimals,
  // there are ways to represent decimals using integers.
  let newValue: number | bigint = value;
  if (
    allowIntegerApproximations &&
    Number.isInteger(value) &&
    !Number.isSafeInteger(value)
  ) {
    newValue = BigInt(value);
  }

  return Intl.NumberFormat('en-US', {
    maximumFractionDigits: 20,
  }).format(newValue);
};
